<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <VariationForm :baseVariation="variation" :loading="loading" @submit-requested="submitRequested"></VariationForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VariationForm from './VariationForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            variation: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { VariationForm },
    computed:
    {
        ...mapState('variations', ['getVariationByIdOutput']),
    },
    methods: {
        ...mapActions('variations', ['getVariationById']),
        ...mapActions('variations', ['putVariation']),
        submitRequested(variations) {
            this.putVariation(variations);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'VariationsList' });
        }

        this.getVariationById(this.$route.query.id);
    },
    watch:
    {
        getVariationByIdOutput: function(variationOutput)
        {
            if(!variationOutput && !variationOutput.data)
            {
                router.push({ name: 'VariationsList' });
            }
            else
            {
                this.variation = variationOutput.data;
                // console.log(this.variation);
                this.loading = false;
            }
        }
    }
}
</script>